import { render } from "./digitalPayments.vue?vue&type=template&id=4b167726&bindings={\"navigate\":\"props\"}"
import script from "./digitalPayments.vue?vue&type=script&lang=js"
export * from "./digitalPayments.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./digitalPayments.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script